module.exports = __webpack_public_path__ + "static/media/brommer.d4864a3d.png";